'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

import Analytics from '../../utils/Analytics';
import { getConfig } from '../../utils/Env';

import './StripePaymentCardEntry.scss';
import './PreferencesForm.scss';

export default class StripePaymentCardEntry extends Component {
    static propTypes = {
        responseHandler: PropTypes.func.isRequired,
        cancelText: PropTypes.string,
        submitText: PropTypes.string,
        onStartRequest: PropTypes.func.isRequired,
        showReferralField: PropTypes.bool,
        showCouponField: PropTypes.bool,
        showAssurance: PropTypes.bool,
        defaultReferralCode: PropTypes.string,
        referral: PropTypes.object,
    };

    static defaultProps = {
        cancelText: 'Cancel',
        submitText: 'Submit Payment',
        showReferralField: false,
        showCouponField: true,
        showAssurance: true,
        defaultReferralCode: '',
    }

    constructor(props) {
        super(props);

        this.state = {
            error: false,
        };
    }

    stripe = null;
    elements = null;
    card = null;

    componentDidMount = () => {
        this.loadStripeJs();
    }

    loadStripeJs = () => {
        let initStripe = () => {
            if (!this.stripe) {
                this.stripe = window.Stripe(getConfig('stripe_pubkey'));
                this.mountStripeElements();
            }
        };

        if (window.Stripe) {
            return initStripe();
        }

        const jsAsset = "https://js.stripe.com/v3/";

        const script = document.createElement('script');
        script.async = false;
        script.src = jsAsset;
        script.addEventListener('load', initStripe);

        document.getElementsByTagName('body')[0].appendChild(script);
    }

    mountStripeElements = () => {
        const { stripe, elements } = this;

        if (!(stripe && elements)) {
            return;
        }

        if (!this.card) {
            this.card = stripe.elements().create('card');

            // Setup instant validation
            this.card.addEventListener('change', (event) => {
                if (event.error) {
                    Analytics.paymentEntryError({'Error': event.error.message});
                }

                this.setState({error: event.error ? event.error.message : false});
            });
        }

        this.card.mount(elements);
    }

    realizeCardElements = (el) => {
        this.elements = el;
        this.mountStripeElements();
    }

    submitPaymentCard = (ev) => {
        ev && ev.preventDefault && ev.preventDefault();
        const { onStartRequest, responseHandler, defaultReferralCode } = this.props;

        onStartRequest();

        const { stripe, card } = this;

        stripe.createToken(card).then(result => {
            let { coupon, referral } = this.refs;

            responseHandler(result, coupon ? coupon.value : false, referral ? referral.value : defaultReferralCode);
        });

        return false;
    }

    render() {
        const { submitText, cancelText, working, cardError, showCouponField, showReferralField, defaultReferralCode,
                showAssurance, onCancel, referral } = this.props;
        const { error } = this.state;

        return (
            <div className="preferences-form stripe-payment-form">
                <form onSubmit={this.submitPaymentCard} id="payment-form" autoComplete="on">
                    {error || cardError ? <span className="error-msg">{error || cardError}</span> : null}

                    <div id="card-elements" ref={this.realizeCardElements}></div>

                    <div className="powered-by">
                    <a href="https://www.stripe.com/">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="119px" height="26px">
                        <path fillRule="evenodd"  opacity="0.502"
                            fill="rgb(66, 71, 112)"
                            d="M113.000,26.000 L6.000,26.000 C2.686,26.000 0.000,23.314 0.000,20.000 L0.000,6.000 C0.000,2.686 2.686,-0.000 6.000,-0.000 L113.000,-0.000 C116.314,-0.000 119.000,2.686 119.000,6.000 L119.000,20.000 C119.000,23.314 116.314,26.000 113.000,26.000 ZM11.128,8.892 L8.571,8.892 L8.571,16.133 L9.918,16.133 L9.918,13.533 L11.128,13.533 C12.602,13.533 13.654,12.586 13.654,11.218 C13.654,9.850 12.602,8.892 11.128,8.892 ZM17.043,10.745 C15.454,10.745 14.328,11.881 14.328,13.502 C14.328,15.112 15.454,16.259 17.043,16.259 C18.632,16.259 19.748,15.112 19.748,13.502 C19.748,11.881 18.632,10.745 17.043,10.745 ZM26.936,10.871 L25.873,14.449 L24.810,10.871 L23.590,10.871 L22.527,14.449 L21.464,10.871 L20.117,10.871 L21.927,16.133 L23.137,16.133 L24.200,12.555 L25.274,16.133 L26.484,16.133 L28.283,10.871 L26.936,10.871 ZM31.252,10.745 C29.747,10.745 28.653,11.871 28.653,13.460 C28.653,15.101 29.768,16.259 31.357,16.259 C31.946,16.259 32.546,16.122 33.146,15.849 L33.146,14.722 C32.599,15.038 32.062,15.217 31.578,15.217 C30.694,15.217 30.063,14.670 29.978,13.870 L33.546,13.870 C33.567,13.691 33.567,13.523 33.567,13.375 C33.567,11.829 32.630,10.745 31.252,10.745 ZM37.724,10.797 C37.577,10.755 37.430,10.745 37.282,10.745 C36.830,10.745 36.367,10.976 35.988,11.397 L35.988,10.871 L34.641,10.871 L34.641,16.133 L35.988,16.133 L35.988,12.618 C36.335,12.176 36.809,11.934 37.251,11.934 C37.409,11.934 37.577,11.955 37.724,11.997 L37.724,10.797 ZM40.808,10.745 C39.303,10.745 38.209,11.871 38.209,13.460 C38.209,15.101 39.325,16.259 40.914,16.259 C41.503,16.259 42.103,16.122 42.703,15.849 L42.703,14.722 C42.155,15.038 41.619,15.217 41.134,15.217 C40.251,15.217 39.619,14.670 39.535,13.870 L43.102,13.870 C43.123,13.691 43.123,13.523 43.123,13.375 C43.123,11.829 42.187,10.745 40.808,10.745 ZM48.912,8.566 L47.554,8.566 L47.554,11.229 C47.144,10.913 46.681,10.745 46.218,10.745 C44.818,10.745 43.840,11.881 43.840,13.502 C43.840,15.122 44.818,16.259 46.218,16.259 C46.681,16.259 47.144,16.091 47.554,15.764 L47.554,16.133 L48.912,16.133 L48.912,8.566 ZM55.690,10.745 C55.238,10.745 54.775,10.913 54.354,11.229 L54.354,8.566 L53.007,8.566 L53.007,16.133 L54.354,16.133 L54.354,15.764 C54.775,16.091 55.238,16.259 55.690,16.259 C57.100,16.259 58.068,15.122 58.068,13.502 C58.068,11.881 57.100,10.745 55.690,10.745 ZM62.310,10.871 L61.037,14.323 L59.774,10.871 L58.395,10.871 L60.405,15.943 L59.395,18.437 L60.700,18.437 L63.689,10.871 L62.310,10.871 ZM73.109,10.288 C73.972,10.288 75.069,10.552 75.933,11.019 L75.933,8.344 C74.992,7.969 74.052,7.825 73.111,7.825 C70.808,7.825 69.273,9.028 69.273,11.038 C69.273,14.181 73.589,13.671 73.589,15.026 C73.589,15.551 73.133,15.721 72.500,15.721 C71.559,15.721 70.345,15.332 69.392,14.814 L69.392,17.525 C70.448,17.979 71.518,18.169 72.497,18.169 C74.858,18.169 76.485,17.003 76.485,14.959 C76.485,11.573 72.144,12.181 72.144,10.903 C72.144,10.460 72.514,10.288 73.109,10.288 ZM82.180,8.014 L80.024,8.014 L80.022,5.548 L77.250,6.138 L77.237,15.247 C77.237,16.928 78.502,18.169 80.187,18.169 C81.115,18.169 81.801,18.001 82.179,17.793 L82.179,15.482 C81.816,15.627 80.024,16.148 80.024,14.475 L80.024,10.435 L82.180,10.435 L82.180,8.014 ZM88.275,8.015 C87.897,7.879 86.570,7.631 85.905,8.853 L85.727,8.014 L83.272,8.014 L83.272,17.966 L86.110,17.966 L86.110,11.219 C86.781,10.338 87.914,10.508 88.275,10.625 L88.275,8.015 ZM91.999,4.230 L89.149,4.836 L89.149,7.149 L91.999,6.543 L91.999,4.230 ZM91.999,8.014 L89.149,8.014 L89.149,17.966 L91.999,17.966 L91.999,8.014 ZM98.125,7.825 C97.012,7.825 96.293,8.349 95.901,8.715 L95.753,8.014 L93.253,8.014 L93.254,21.268 L96.093,20.664 L96.099,17.451 C96.507,17.750 97.114,18.169 98.108,18.169 C100.139,18.169 101.997,16.535 101.997,12.927 C101.997,9.621 100.119,7.825 98.125,7.825 ZM107.049,7.825 C104.348,7.825 102.704,10.121 102.704,13.013 C102.704,16.437 104.642,18.169 107.408,18.169 C108.765,18.169 109.784,17.861 110.555,17.433 L110.555,15.146 C109.781,15.536 108.893,15.774 107.766,15.774 C106.659,15.774 105.684,15.382 105.557,14.051 L111.116,14.051 C111.129,13.898 111.154,13.303 111.154,13.028 C111.154,10.120 109.746,7.825 107.049,7.825 ZM107.031,10.140 C107.728,10.140 108.468,10.677 108.468,11.955 L105.532,11.955 C105.532,10.676 106.321,10.140 107.031,10.140 ZM97.446,15.661 C96.780,15.661 96.383,15.421 96.107,15.122 L96.090,10.903 C96.386,10.578 96.795,10.340 97.446,10.340 C98.485,10.340 99.200,11.504 99.200,12.989 C99.200,14.518 98.496,15.661 97.446,15.661 ZM55.406,15.101 C55.038,15.101 54.669,14.943 54.354,14.628 L54.354,12.376 C54.669,12.060 55.038,11.902 55.406,11.902 C56.164,11.902 56.690,12.555 56.690,13.502 C56.690,14.449 56.164,15.101 55.406,15.101 ZM46.513,15.101 C45.744,15.101 45.218,14.449 45.218,13.502 C45.218,12.555 45.744,11.902 46.513,11.902 C46.881,11.902 47.249,12.060 47.554,12.376 L47.554,14.628 C47.249,14.943 46.881,15.101 46.513,15.101 ZM40.756,11.786 C41.355,11.786 41.787,12.281 41.829,12.997 L39.535,12.997 C39.598,12.271 40.103,11.786 40.756,11.786 ZM31.199,11.786 C31.799,11.786 32.231,12.281 32.273,12.997 L29.978,12.997 C30.042,12.271 30.547,11.786 31.199,11.786 ZM17.043,15.133 C16.254,15.133 15.707,14.470 15.707,13.502 C15.707,12.534 16.254,11.871 17.043,11.871 C17.822,11.871 18.369,12.534 18.369,13.502 C18.369,14.470 17.822,15.133 17.043,15.133 ZM10.939,12.439 L9.918,12.439 L9.918,9.987 L10.939,9.987 C11.718,9.987 12.265,10.482 12.265,11.218 C12.265,11.944 11.718,12.439 10.939,12.439 Z" />
                        </svg>
                    </a>
                    </div>

                    {showCouponField ?
                        <div className="with-label coupon-code">
                            <label>Coupon Code <em>(optional)</em></label>
                            <input disabled={working} type="text" data-stripe="coupon-code" ref="coupon" />
                        </div>
                    : null}

                    {showReferralField && !referral ?
                        <div className="with-label referral">
                            <label>Referral Code <em>(optional)</em></label>
                            <input defaultValue={defaultReferralCode} type="text" ref="referral" />
                        </div>
                    : null}

                    {showReferralField && referral ?
                        <div className="with-label referral">
                            <label>Referred By <em>(optional)</em></label>
                            <input defaultValue={referral.name} readOnly disabled type="text" />
                            <input defaultValue={defaultReferralCode} type="hidden" ref="referral" />
                        </div>
                    : null}

                    {this.props.children}

                    <footer>
                        {onCancel ?
                            <button className="cancel-btn" disabled={working} onClick={onCancel}>{cancelText}</button>
                        : null}
                        <button className="stripe-submit" type="submit" disabled={working}>
                            {working ? <span><i className="icon-spinner" /> Working</span> : submitText}
                        </button>
                        {showAssurance ?
                            <p className="assurance">Your card won't be charged just yet.</p>
                        : null}
                    </footer>

                </form>
            </div>
        );
    }
}
